import state from "@/modules/businesses/vuex/state";
import mutations from "@/modules/businesses/vuex/mutations";
import actions from "@/modules/businesses/vuex/actions";
import getters from "@/modules/businesses/vuex/getters";

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
